export const services = [
  {
    icon: "FaHandsHelping",
    title: "Personal Care Assistance",
    description: "Bathing, grooming, dressing, and hygiene support with dignity and respect."
  },
  {
    icon: "FaHeart",
    title: "Companion Care",
    description: "Meaningful companionship, conversation, and engagement to combat loneliness."
  },
  {
    icon: "FaPills",
    title: "Medication Management",
    description: "Timely medication reminders and administration monitoring."
  },
  {
    icon: "FaCar",
    title: "Mobility & Transportation",
    description: "Safe assistance with movement, errands, and medical appointments."
  },
  {
    icon: "FaUtensils",
    title: "Meal Preparation & Nutrition",
    description: "Healthy, home-cooked meals tailored to dietary needs and preferences."
  },
  {
    icon: "FaBriefcaseMedical",
    title: "Post-Surgery & Recovery Care",
    description: "Specialized support during recovery to ensure a smooth healing process."
  }
];
